import { lazy, type ComponentType } from 'react'

/**
 * `React.lazy` for a named export: `lazyPage(() => import('./FooPage'), 'FooPage')`.
 * Keeps the page modules' named exports instead of forcing default exports.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- pages have differing prop types
export function lazyPage<K extends string, C extends ComponentType<any>>(
  load: () => Promise<Record<K, C>>,
  name: K,
) {
  return lazy(async () => {
    const module = await load()
    // After a deploy a stale chunk fails; main.tsx then prevents the error and reloads the page,
    // and Vite resolves the import to undefined. Wait for that reload instead of throwing.
    if (!module) return new Promise<never>(() => {})
    return { default: module[name] }
  })
}
